import React, { Component } from "react";
import { toast} from 'react-toastify';

export const mensajeExito = (mensaje) => {
    toast.success(mensaje,{
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    }) 
};

